module.exports = require("bluebird");


/*****************
 ** WEBPACK FOOTER
 ** external "bluebird"
 ** module id = 30
 ** module chunks = 0
 **/